module.exports = __webpack_public_path__ + "img/forget.967bedc0.svg";